// extracted by mini-css-extract-plugin
export var mainLayout = "Layout-module--mainLayout--1KPRN";
export var logo = "Layout-module--logo--oHMho";
export var container = "Layout-module--container--2IpcU";
export var fullWidthContainer = "Layout-module--fullWidthContainer--3uZQa";